/**
 * Viewport names and their sizes
 * Sizes match our SCSS media queries
 * @type {Object}
 */
const viewports = {
  xxs: 360,
  xs: 480,
  s: 615,
  m: 750,
  l: 860,
  xl: 1020,
  xxl: 1100,
}

/**
 * Provides a JS hook that determines whether a media query is active
 * @param  {String} size Viewport size to check
 * @return {Boolean}     Whether or not this viewport is active
 */
export function isMediaActive(size) {
  return window.matchMedia(`(min-width: ${viewports[size]}px)`).matches
}
